import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CTA_PRINCIPAL, MOCKUP, MOCKUP_ALT, PRECIO_ANTERIOR, PRECIO_LARGO, heroBullets } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy text-white" data-id="element-62" data-mp="9igx9dyd3yma">
      <div className="mx-auto flex min-h-[100svh] w-full max-w-6xl flex-col justify-center gap-4 px-5 pb-5 pt-4 sm:min-h-0 sm:gap-6 sm:px-8 sm:py-12 lg:grid lg:grid-cols-[1.02fr_0.98fr] lg:grid-rows-[auto_auto] lg:content-center lg:gap-x-12 lg:gap-y-6 lg:py-16" data-id="element-63" data-mp="4n9wadwh9812">
        {/* Copy */}
        <div className="lg:col-start-1 lg:row-start-1" data-id="element-64" data-mp="s9zxjd104ykm">
          <p className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-white/10 px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-widest text-celeste sm:mb-5 sm:gap-2 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-65" data-mp="ncgl8inv6vvb">
            <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-66" data-mp="3825xcnx6o3kb" />
            Producto digital · Ley 25.326
          </p>

          <h1 className="font-display text-[1.6rem] font-extrabold leading-[1.08] tracking-tight sm:text-[2.6rem] lg:text-[3.1rem]" data-id="element-67" data-mp="3j924lm8avmuh">
            ¿Seguís figurando en Veraz y{' '}
            <span className="relative inline-block" data-id="element-68" data-mp="399bcfr77pjxk">
              <span className="relative z-10" data-id="element-69" data-mp="3e9fs5f0aqamq">no sabés cómo salir</span>
              <span className="absolute inset-x-[-4px] bottom-[0.06em] z-0 h-[0.34em] bg-oro/80" aria-hidden="true" data-id="element-70" data-mp="3e7l7m1sxskj6" />
            </span>
            ?
          </h1>

          <p className="mt-2.5 max-w-xl text-[15px] leading-snug text-white/75 sm:mt-5 sm:text-xl sm:leading-relaxed" data-id="element-71" data-mp="35au9zkyqkxmh">
            Descubrí qué está bloqueando tu historial y seguí el protocolo correcto para{' '}
            <strong className="font-semibold text-white" data-id="element-72" data-mp="2hj5ejvqmbt1b">
              empezar a recuperar tu nombre financiero
            </strong>
            .
          </p>

          <ul className="mt-5 hidden grid-cols-1 gap-x-6 gap-y-2 sm:grid sm:grid-cols-2" data-id="element-73" data-mp="2lk8wqow5215p">
            {heroBullets.map(b => <li key={b} className="flex items-start gap-2.5 text-[15px] font-medium text-white/90" data-id="element-74" data-mp="s3umzlkswo5c">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-celeste" aria-hidden="true" data-id="element-75" data-mp="ic873bxiq0w9" />
                {b}
              </li>)}
          </ul>
        </div>

        {/* Mockup oficial */}
        <div className="min-h-0 lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-76" data-mp="1b0njrrt6g74f">
          <div className="mx-auto w-full max-w-[300px] rounded-2xl bg-white p-2 ring-1 ring-white/15 sm:max-w-md sm:p-4 lg:max-w-none" data-id="element-77" data-mp="1ayji7gir3k7b">
            <img src={MOCKUP} alt={MOCKUP_ALT} className="mx-auto max-h-[29svh] w-auto object-contain sm:max-h-[340px] lg:max-h-[430px] lg:w-full" loading="eager" width={1264} height={1264} data-id="element-78" data-mp="1126m6bzqgu9e" />
          </div>
        </div>

        {/* Precio + CTA */}
        <div className="max-w-md lg:col-start-1 lg:row-start-2" data-id="element-79" data-mp="3hq25sw90g49b">
          <div className="mb-2.5 flex flex-wrap items-baseline gap-x-2.5 gap-y-0.5" data-id="element-80" data-mp="1xacgp6hknput">
            <span className="font-mono text-[13px] text-white/45 line-through" data-id="element-81" data-mp="21a4rlpufu83c">
              {PRECIO_ANTERIOR}
            </span>
            <span className="font-mono text-xl font-bold text-white sm:text-2xl" data-id="element-82" data-mp="268g282sk4mmm">
              {PRECIO_LARGO}
            </span>
            <span className="text-[13px] text-white/60" data-id="element-83" data-mp="2b2kaqqhh12pt">Pago único</span>
          </div>
          <CtaButton label={CTA_PRINCIPAL} data-id="element-84" data-mp="2g1ww16sp21qa" />
          <p className="mt-2 text-center text-[12px] text-white/55" data-id="element-85" data-mp="2kydryn64xkdx">
            Acceso digital inmediato · Manual + 3 bonos incluidos
          </p>
        </div>
      </div>
    </header>;
}